import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { FieldWrapper } from '../Retails.styles';

export const SearchFieldWrapper = styled(FieldWrapper)`
    display: flex;
`;

export const SearchFieldContainer = styled.div`
    width: 100%;
`;

export const SuggestionsWrapper = styled.div`
    max-height: 28.125rem;
    overflow-y: auto;
    padding: ${getPurpurSpacing('300')};
`;

export const SuggestionsList = styled.div`
    background: ${getPurpurColor('functionalWhite')};
    border-radius: 0.5rem;
    box-shadow: 0 0.25rem 0.5rem 0 rgba(34, 34, 34, 0.08);

    * + * {
        border-top: 2px solid ${getPurpurColor('gray50')};
    }
`;

export const PositionSuggestionContainer = styled(SuggestionsList)`
    ${purpurMedia('xl')`
        display: none;
    `};
`;

export const SuggestionItemWrapper = styled.button`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${getPurpurSpacing('250')} ${getPurpurSpacing('300')};
    cursor: pointer;

    &:hover {
        color: ${getPurpurColor('purple500')};
    }
    &:focus-visible {
        outline: solid 3px #0099ff;
        outline-offset: 3px;
    }
    &:focus:not(:focus-visible) {
        outline: unset;
    }
`;

export const NotFoundWrapper = styled.div`
    padding: ${getPurpurSpacing('300')};
    font-size: 0.9375rem;
`;

export const QuickLinksLabelsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: ${getPurpurSpacing('200')};
    margin-bottom: ${getPurpurSpacing('200')};
`;

export const PositionSuggestionLabel = styled.div`
    display: flex;
    align-items: center;
    gap: ${getPurpurSpacing('100')};
`;
